export const TextStyles = {
  variants: {
    link: {
      color: 'nexusTeal.100',
      fontSize: 'sm',
      fontWeight: 'medium',
      textDecoration: 'underline',
      _hover: {
        color: 'nexusTeal.200',
      },
    },
  },
};
